var freedom_UproxyPeerConnection;
(function (freedom_UproxyPeerConnection) {
    var FreedomPcImpl = (function () {
        function FreedomPcImpl(module_, dispatchEvent_, config) {
            var _this = this;
            this.module_ = module_;
            this.dispatchEvent_ = dispatchEvent_;
            this.handleSignalMessage = function (signal, continuation) {
                _this.pc_.handleSignalMessage(signal);
                continuation();
            };
            this.negotiateConnection = function (continuation) {
                _this.pc_.negotiateConnection().then(continuation).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': negotiateConnection: error: ' + e.toString()
                    });
                });
            };
            this.close = function (continuation) {
                _this.pc_.close();
                _this.pc_.onceDisconnected.then(continuation).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': close: error: ' + e.toString()
                    });
                });
            };
            this.onceConnected = function (continuation) {
                _this.pc_.onceConnected.then(continuation).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': onceConnected: error: ' + e.toString()
                    });
                });
            };
            this.onceConnecting = function (continuation) {
                _this.pc_.onceConnecting.then(continuation).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': onceConnecting: error: ' + e.toString()
                    });
                });
            };
            this.onceDisconnected = function (continuation) {
                _this.pc_.onceDisconnected.then(continuation).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': onceDisconnected: error: ' + e.toString()
                    });
                });
            };
            this.onceDataChannelClosed = function (channelLabel, continuation) {
                if (channelLabel in _this.pc_.dataChannels) {
                    _this.pc_.dataChannels[channelLabel].onceClosed.then(continuation);
                }
                else {
                    continuation();
                }
            };
            this.onceDataChannelOpened = function (channelLabel, continuation) {
                if (channelLabel in _this.pc_.dataChannels) {
                    _this.pc_.dataChannels[channelLabel].onceOpened.then(continuation);
                }
                else {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': onceDataChannelOpened: non-existant label: ' + channelLabel
                    });
                }
            };
            this.dispatchDataChannelEvents_ = function (dataChannel) {
                dataChannel.dataFromPeerQueue.setSyncHandler(function (data) {
                    _this.dispatchEvent_('dataFromPeer', { channelLabel: dataChannel.getLabel(), message: data });
                });
            };
            this.openDataChannel = function (channelLabel, continuation) {
                var dataChannel = _this.pc_.openDataChannel(channelLabel);
                dataChannel.onceOpened.then(function () {
                    _this.dispatchDataChannelEvents_(dataChannel);
                    continuation();
                }).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': openDataChannel: ' + e.toString()
                    });
                });
            };
            this.closeDataChannel = function (channelLabel, continuation) {
                if (channelLabel in _this.pc_.dataChannels) {
                    _this.pc_.dataChannels[channelLabel].close();
                }
                continuation();
            };
            this.send = function (channelLabel, data, continuation) {
                if (!(channelLabel in _this.pc_.dataChannels)) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': send: non-existant label: ' + channelLabel
                    });
                    return;
                }
                _this.pc_.dataChannels[channelLabel].send(data).then(continuation).catch(function (e) {
                    continuation(null, {
                        'message': _this.pc_.peerName + ': send: ' + e.toString()
                    });
                });
            };
            this.log_ = new Logging.Log('uproxy-peerconnection-freedom-wrapper');
            this.log_.debug('making new pc from config: ' + JSON.stringify(config));
            if (Array.isArray(config)) {
                config = config[0];
            }
            this.pc_ = new WebRtc.PeerConnection(config);
            this.pc_.signalForPeerQueue.setSyncHandler(function (signal) {
                _this.dispatchEvent_('signalForPeer', signal);
            });
            this.pc_.peerOpenedChannelQueue.setSyncHandler(function (dataChannel) {
                _this.dispatchDataChannelEvents_(dataChannel);
                _this.dispatchEvent_('peerOpenedChannel', dataChannel.getLabel());
            });
        }
        return FreedomPcImpl;
    })();
    freedom_UproxyPeerConnection.FreedomPcImpl = FreedomPcImpl;
})(freedom_UproxyPeerConnection || (freedom_UproxyPeerConnection = {}));
//# sourceMappingURL=uproxypeerconnection.js.map